import * as React from 'react';

interface IFormSearchWrapperProps {
  children: React.ReactNode;
  onSearch(): void;
  id?: string;
}

export const FormSearchWrapper = React.memo(
  ({children, onSearch, id}: IFormSearchWrapperProps): JSX.Element => (
    <form
      id={id || 'searchForm'}
      onSubmit={ev => {
        ev.preventDefault();

        setTimeout(() => onSearch());
      }}
    >
      {children}
    </form>
  ),
);
